"use client";
import { useEffect, useMemo } from "react";
import {
  DayPicker,
  FooterProps,
  Matcher,
  ModifiersClassNames,
  ModifiersStyles,
  SelectMultipleModifiers,
  SelectRangeModifiers,
} from "react-day-picker";

import "./datePickerStyle.scss";
import { Caption } from "./caption";
import { Container, Typography } from "ct-design";
export interface DateRangeProps {
  onDateSelect: (
    values: SelectRangeModifiers | SelectMultipleModifiers
  ) => void;
  selectedDays: unknown;
  noOfMonths: number;
  mode: "default" | "multiple" | "single" | "range" | undefined;
  customHeader: React.FC;
  min?: number;
  max?: number;
  disabledDays?: Matcher | Matcher[]; // [{to, from},{}]
  footer?: FooterProps;
  modifiersStyles?: ModifiersStyles;
  modifiersClassName?: ModifiersClassNames;
  fromMonth?: Date;
  toDate?: Date;
  defaultMonth?: Date;
}
const weekdayLabels = {
  0: "Sun",
  1: "Mon",
  2: "Tue",
  3: "Wed",
  4: "Thu",
  5: "Fri",
  6: "Sat",
};

const Calendar: React.FC<DateRangeProps> = ({
  onDateSelect, // date select
  selectedDays,
  noOfMonths,
  mode,
  footer,
  customHeader,
  disabledDays,
  fromMonth,
  toDate,
  defaultMonth,
}) => {
  const a = "134643a2a23a2aads2ssasss23ssaaassssfaaassssssss2sa22";

  const styleConfigurableVariables = useMemo(
    () => ({
      "--rdp-cell-size": "40px" /* Cell size */,
      "--rdp-accent-color": "#1A1A1A",
      "--rdp-outline": `1.5px solid #1A1A1A` /* Outline border for focused elements */,
      "--rdp-selected-range-color": "#F3F3F3",
    }),
    []
  );

  useEffect(() => {
    const calendarElement = document.getElementById(a);
    if (calendarElement) {
      Object.keys(styleConfigurableVariables).forEach((styleVar) => {
        calendarElement?.style?.setProperty(
          styleVar,
          styleConfigurableVariables[styleVar]
        );
      });
    }
  }, []);

  const formatWeekdayName = (date: Date) => {
    const day = date.getDay();
    return (
      <Typography
        variant="B3"
        colorCode={day > 0 && day < 6 ? "#808080" : "#C83232"}
      >
        {weekdayLabels[day as keyof typeof weekdayLabels]}
      </Typography>
    );
  };

  const formatWeekNumber = (weekNumber: number) => {
    // Subtract 1 to make Monday as 0
    return weekNumber - 1;
  };

  return (
    <Container css={{}} display="flex" alignItems="center">
      <DayPicker
        id={a}
        weekStartsOn={1}
        numberOfMonths={noOfMonths}
        mode={mode}
        selected={selectedDays}
        onSelect={onDateSelect}
        disabled={disabledDays}
        components={{ Caption } || { customHeader }}
        footer={footer}
        fromMonth={fromMonth}
        toDate={toDate}
        formatters={{ formatWeekdayName, formatWeekNumber }}
        defaultMonth={defaultMonth}
      />
    </Container>
  );
};

export default Calendar;
